import {createElement, createSpinner, empty} from "./Dom.ts";

export const fadeOutFadeIn = (source: HTMLElement | null, target: HTMLElement | null) => {
    return new Promise((resolve, reject) => {
        if (source && target) {
            source.style.setProperty('--animate-duration', '100ms');
            target.style.setProperty('--animate-duration', '100ms');
            fadeOut(source, '100ms').then(() => {
                fadeIn(target, '100ms').then(() => {
                    resolve(true)
                })
            })
        } else { reject('Element not found')}
    })
}

export const fadeIn = (target: HTMLElement | null, duration: string = '300ms'): Promise<HTMLElement|null> => {
    return new Promise(resolve => {
        if (!target) return resolve(null)
        if(!target.classList.contains('d-none')) return resolve(target)
        target.style.setProperty('--animate-duration', duration);
        target.classList.remove('d-none')
        target.classList.remove('animate__animated', 'animate__fadeOut')
        target.classList.add('animate__animated', 'animate__fadeIn')
        target.addEventListener('animationend', () => {
            target.classList.remove('d-none')
            resolve(target)
        }, {once: true})
    })
}

export const fadeOut = (target: HTMLElement | null, duration: string = '300ms', hide: boolean = true): Promise<HTMLElement|null> => {
    return new Promise(resolve => {
        if (!target) return resolve(null)
        const clear = () => {
            if (hide) target.classList.add('d-none')
            resolve(target)
        }
        if(target.classList.contains('d-none')) return resolve(target)
        target.style.setProperty('--animate-duration', duration);
        target.classList.remove('animate__animated', 'animate__fadeIn')
        target.classList.add('animate__animated', 'animate__fadeOut')
        target.addEventListener('animationend', clear, {once: true})
    })
}

export const slideIn = (target: HTMLElement) => {
    target.classList.remove('d-none')
    animateCSS(target, 'fadeInDown').then(() => {
    })
}

export const slideOut = (target: HTMLElement) => {
    animateCSS(target, 'fadeOutUp').then(() => {
        target.classList.add('d-none')
    })
}


const animateCSS = (element: HTMLElement, animation: string, prefix = 'animate__') =>
    // We create a Promise and return it
    new Promise((resolve) => {
        const animationName = `${prefix}${animation}`;

        element.classList.add(`${prefix}animated`, animationName);

        // When the animation ends, we clean the classes and resolve the Promise
        function handleAnimationEnd(event: Event) {
            event.stopPropagation();
            element.classList.remove(`${prefix}animated`, animationName);
            resolve('Animation ended');
        }

        element.addEventListener('animationend', handleAnimationEnd, {once: true});
    });


export const animateLoadingButton = (button: HTMLElement|null, texte?: string) => {
    if(button) {
        const original = button.innerHTML
        const span = createElement('span')
        const resetBtn = () => {
            fadeOut(span).then(() => {
                button.innerHTML = original
            })
        }

        empty(button)
        const spinner = createSpinner()
        span.appendChild(spinner)
        if(texte) {
            const texteElement = createElement('span')
            texteElement.innerText = texte
            span.appendChild(texteElement)
        }
        button.appendChild(span)

        return {
            resetBtn,
            spinner,
        }
    }
}